import Cookies from "js-cookie";

export const getCurrentLanguagePreference = () =>
  Cookies.get("selectedLanguage") || process?.env?.VUE_APP_I18N_LOCALE || "fr";
